// extracted by mini-css-extract-plugin
export default {"container":"styles_container__f7VpM","card":"styles_card__jJTGG"};